import {AnyAction, Dispatch,bindActionCreators} from 'redux';
import {ConnectedProps, connect} from 'react-redux';
import {updateSetting} from '../actions/settingsActions';
import React from 'react';
import Toggle from './Toggle';

import {StoreState} from '../typescript/storeTypes';


export class OrderByToggle extends React.PureComponent<Props> {

    onToggleChange = (orderBy: 'tscode'|'person'): void => {
        this.props.updateSetting('defaultOrderBy', orderBy);
    };

    render() {
        return (
            <Toggle value1="tscode" displayValue1="TSCODE"
                    value2="person" displayValue2="PERSON"
                    onChange={this.onToggleChange}
                    currentValue={this.props.defaultOrderBy} />
        );
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type MappedProps = ConnectedProps<typeof connector>;

type Props = MappedProps;

function mapStateToProps(state: StoreState) {
    return {
        defaultOrderBy: state.settings.defaultOrderBy
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({updateSetting}, dispatch);
}

export default connector(OrderByToggle);
